(function () {
    'use strict';

    angular
        .module('app.consulting')
        .factory('ConsultingService', Service);

    Service.$inject = ['$http', '$q'];

    function Service($http, $q) {
        var service = {
            getExpertises: getExpertises,
            getAppointmentTools: getAppointmentTools,
            getConsultantSchedules: getConsultantSchedules,
            getConsultant: getConsultant,
            saveAppointment: saveAppointment,
            editAppointment: editAppointment,
            checkAppointmentDate: checkAppointmentDate
        };

        var serviceBase = "/";
        return service;

        function getExpertises() {
            var deferred = $q.defer();

            $http.get(serviceBase + 'api/Consulting/Expertises')
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function saveAppointment(entity) {
            var deferred = $q.defer();

            $http.post("/Consulting/Appointment", entity)
                .then(addComplete)
                .catch(addFailed);

            function addComplete(response) {
                deferred.resolve(response.data);
            }

            function addFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function editAppointment(entity) {
            var deferred = $q.defer();

            $http.put("/Consulting/Appointment/" + entity.Id, entity)
                .then(addComplete)
                .catch(addFailed);

            function addComplete(response) {
                deferred.resolve(response.data);
            }

            function addFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function getAppointmentTools() {
            var deferred = $q.defer();

            $http.get(serviceBase + 'api/Consulting/AppointmentTools')
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getConsultant(expertiseId) {
            var deferred = $q.defer();

            $http.get(serviceBase + 'api/Consulting/Consultants/' + expertiseId)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getConsultantSchedules(consultantId) {
            var deferred = $q.defer();

            $http.get(serviceBase + 'api/Consulting/ConsultantSchedules/' + consultantId)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function checkAppointmentDate(consultantId, startDate, endDate) {
            var deferred = $q.defer();

            $http.get(serviceBase + 'api/Consulting/CheckDate/' + consultantId + '?StartDate=' + startDate + "&EndDate=" + endDate)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();